import type { InternalNamePath } from 'antd/es/form/interface';

const FIELD_LABELS: Record<string, string> = {
  Phone: 'Мобильный телефон',
  NameFirst: 'Имя',
  NameLast: 'Фамилия',
  Date: 'Дата',
  TimeStart: 'Время начала',
  TimeEnd: 'Время окончания',
  DurationHour: 'Длительность',
  DurationMinute: 'Длительность',
  Employee: 'Исполнитель',
  EmployeePayoff: 'Заработная плата',
  Comment: 'Комментарий',
  Tags: 'Теги',
  Color: 'Цвет записи',
  products: 'Товары',
};

const SERVICE_FIELD_LABELS: Record<string, string> = {
  id: 'Название',
  upsaleEmployee: 'Допродажа',
  quantity: 'Кол-во',
  price: 'Цена',
  discountCurrency: 'Скидка',
  discountPercentage: 'Скидка',
};

// Человеческая подпись поля для сводки ошибок валидации: antd отдаёт путь
// поля (['services', 0, 'quantity']), а тестировщик должен прочитать
// «Услуги (строка 1), Кол-во».
export const getValidationFieldLabel = (name: InternalNamePath): string => {
  if (name[0] === 'services') {
    const rowPart =
      typeof name[1] === 'number' ? ` (строка ${name[1] + 1})` : '';
    const subKey = typeof name[2] === 'string' ? name[2] : '';
    const subLabel = SERVICE_FIELD_LABELS[subKey];

    return `Услуги${rowPart}${subLabel ? `, ${subLabel}` : ''}`;
  }

  const key = String(name[0] ?? '');

  return FIELD_LABELS[key] ?? key;
};
